import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "self-center text-center font-heading text-32 font-[690] uppercase [font-stretch:_190%]"
}
const _hoisted_3 = {
  key: 0,
  class: "relative"
}
const _hoisted_4 = {
  key: 0,
  class: "relative flex md:justify-center mt-10 md:mt-[3.75rem]"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Meer laden ")
const _hoisted_6 = {
  key: 1,
  class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_vue = _resolveComponent("svg-vue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["relative flex flex-col justify-center", { 'pt-10 md:pt-[3.75rem]': $setup.loading }])
    }, [
      _createVNode(_Transition, {
        name: "fade",
        tag: "div",
        class: "justify-self-center"
      }, {
        default: _withCtx(() => [
          (!$setup.loading && $setup.blogposts.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Geen evenementen gevonden"))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!$setup.loading || ($setup.loading && $setup.page > 1))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                ($setup.blogposts && $setup.blogposts.length)
                  ? (_openBlock(), _createBlock(_TransitionGroup, {
                      key: 0,
                      class: "md:-m-5 -m-[1.875rem] flex flex-wrap",
                      name: "fade",
                      tag: "div"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.blogposts, (blogpost) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "flex w-full flex-col p-[1.875rem] md:p-5 md:w-1/2 lg:w-1/3",
                            key: blogpost.id
                          }, [
                            _createVNode($setup["BlogCard"], { blogpost: blogpost }, null, 8 /* PROPS */, ["blogpost"])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_TransitionGroup, {
        name: "fade-absolute",
        mode: "out-in",
        tag: "div",
        class: _normalizeClass(["relative flex h-0 w-full justify-center overflow-hidden transition-all", { '!h-14': $setup.canLoadMore || $setup.loading }])
      }, {
        default: _withCtx(() => [
          ($setup.canLoadMore)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.loadMore())),
                  class: "btn btn-black"
                }, [
                  _hoisted_5,
                  _createVNode(_component_svg_vue, {
                    icon: "arrow",
                    class: "ml-[.625rem] h-6 w-auto"
                  })
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode($setup["Spinner"])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class"])
    ], 2 /* CLASS */)
  ]))
}